export default "__VITE_ASSET__DUeU2a9o__"